import { render, staticRenderFns } from "./AmexAprobar.vue?vue&type=template&id=2feafd7c&scoped=true&"
import script from "./AmexAprobar.vue?vue&type=script&lang=js&"
export * from "./AmexAprobar.vue?vue&type=script&lang=js&"
import style0 from "./AmexAprobar.vue?vue&type=style&index=0&id=2feafd7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feafd7c",
  null
  
)

component.options.__file = "AmexAprobar.vue"
export default component.exports